module.exports = __webpack_public_path__ + "img/img-qr-sec-06.png";